import { useContext } from "react";
import { StockListContext } from "../../contexts/StockListContext";
import { UseQueryResult } from "@tanstack/react-query";
import {
  BuyerProductGetResponseType,
  SupplierGetResponseType,
} from "@sellar-io/api-v2/types";

export const useStockListContext = () => {
  const context = useContext(StockListContext);
  if (context === undefined) {
    const error = new Error(
      "useStockListContext must be within StockListContextProvider",
    );

    console.error(error.stack);

    // NOTE: return stub data in prod to prevent error being thrown,
    // timing issue in prod when components haven't finished being unmounted but context is not available
    if (
      import.meta.env.VITE_ENV === "production" ||
      import.meta.env.VITE_ENV === "staging"
    ) {
      return {
        openOrderList: [],
        supplierQuery: {
          data: undefined,
          error: null,
          isLoading: false,
          isFetching: false,
          refetch: async () => ({ data: undefined, error: null }),
        } as UseQueryResult<SupplierGetResponseType | undefined>,
        productApi: {
          data: undefined,
          error: null,
          isLoading: false,
          isFetching: false,
          refetch: async () => ({ data: undefined, error: null }),
        } as UseQueryResult<BuyerProductGetResponseType | undefined>,
        categoryId: undefined,
        supplierIdOrUrlId: undefined,
        connection: undefined,
        setEditing: () => {},
        editing: false,
        submittedOrder: undefined,
        supplierStorefront: undefined,
        setCheckoutSelectedFulfillmentType: () => {},
        checkoutSelectedFulfillmentType: undefined,
        connectionQuery: undefined,
        basketedProductsQuery: undefined,
        calculatedDeliveryOffers: [],
        setUnAuthorisedUserPostcode: () => {},
        unAuthorisedUserPostcode: undefined,
        courierFulfillmentType: undefined,
        haulierFulfillmentType: undefined,
        setSelectedFulfillmentType: () => {},
        selectedFulfillmentType: undefined,
        isStorefrontLoading: false,
      };
    }

    throw error;
  }

  return context;
};
